import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  Modal, Form, Alert, Row, Skeleton,
} from 'antd';
import { FormattedMessage } from 'react-intl';
import { cancelReinstateVehicle, requestReinstateVehicle } from '../../../../state/ui/configuration/vehicles/vehicleUiActions';
import {
  selectEditState, selectReinstateVehicleRequest,
} from '../../../../state/ui/configuration/vehicles/vehicleUiReducer';
import { selectVehicle, selectVehicles } from '../../../../state/domain/vehicles/vehicleReducer';
import Text from 'antd/lib/typography/Text';





/**
 * A component allowing a bynx admin user to reinstate a vehicle to the active fleet
 */
const ReinstateVehicle = Form.create({ name: 'retire-vehicle' })(({
  visible, onCancel, form, vehicleId, vehicle, onUpdate, isSubmitting, validationBox, hasDuplicateReg, hideReinstatedInfoRow
}) => {
  const { resetFields } = form;
  const [validationMessage, setValidationMessage] = useState();
  const intl = useIntl();
  
  const submitVehicleRepairs = () => {
    form.validateFields((err) => {
      if (err) return; // Nothing more to do.

      onUpdate(vehicleId, vehicle.regNumber);
      hideReinstatedInfoRow(vehicleId);
    });
  };

  // Reset fields when it becomes visible.
  useEffect(() => {
    if (visible) {
      resetFields();
      setValidationMessage(null);
    }
  }, [resetFields, visible, vehicleId, setValidationMessage]);

  useEffect(() => {
         setValidationMessage(validationBox ? validationBox.errors[0] : (hasDuplicateReg ? intl.formatMessage({ id: 'vehicleRegInActiveUse' }) : null));
  }, [validationBox, setValidationMessage, vehicle, hasDuplicateReg, intl]);

  return (
    <Modal
      destroyOnClose
      title={<FormattedMessage id="reinstateVehicle" />}
      okText={<FormattedMessage id="reinstate" />}
      visible={visible}
      onOk={submitVehicleRepairs}
      onCancel={onCancel}
      confirmLoading={isSubmitting}
      okButtonProps={{ disabled:  !!validationMessage }}
    >
      <Form layout="vertical">
       {validationMessage ? 
       <Alert
        description={<Row key={validationMessage}>{validationMessage}</Row>}
        type="warning" showIcon
        /> : ''}
      <Row className="vehicle-details-content-row">
        <Row style={{ marginBottom: '12px' }}>
          <Text strong><FormattedMessage id="regNumber" /></Text>
        </Row>
        <Row>
          <Text>{vehicle ? vehicle.regNumber : <Skeleton title={false} paragraph={{ width: 200, rows: 1 }} />}</Text>
        </Row>
      </Row>
      <Row className="vehicle-details-content-row">
        <Row style={{ marginBottom: '12px' }}>
          <Text strong><FormattedMessage id="vehicleDescription" /></Text>
        </Row>
        <Row>
          <Text>{vehicle ? vehicle.vehicleDescription || <FormattedMessage id="notProvided" /> : <Skeleton title={false} paragraph={{ width: 200, rows: 1 }} />}</Text>
        </Row>
      </Row>
      </Form>
    </Modal>
  );
});

const mapStateToProps = (state) => {
  const editVehicleDamageState = selectEditState(state);
  const submitRequest = selectReinstateVehicleRequest(state);
  const vehicles = selectVehicles(state);
  const currentVehicle = editVehicleDamageState.vehicleId ? selectVehicle(state, editVehicleDamageState.vehicleId) : null
  var hasDuplicateReg = false;
  if (vehicles && currentVehicle)
  {
    hasDuplicateReg = vehicles.find(vehicle => vehicle.active && vehicle.regNumber === currentVehicle.regNumber);
  }
  return {
    visible: editVehicleDamageState.reinstatingVehicle,
    vehicleId: editVehicleDamageState.vehicleId,
    vehicle: currentVehicle,
    isSubmitting: submitRequest ? submitRequest.isLoading : false,
    validationBox: submitRequest ? submitRequest.error : undefined,
    hasDuplicateReg: hasDuplicateReg,
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdate: (vehicleId, regNumber) => dispatch(requestReinstateVehicle(vehicleId, regNumber)),
  onCancel: () => dispatch(cancelReinstateVehicle()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReinstateVehicle);
